import { NavLink, useLocation, useNavigate } from "react-router-dom";
import styles from './index.module.css';
import LogoImg from '../../assets/images/brand/study_hub_logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faWallet } from "@fortawesome/free-solid-svg-icons";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectUserDetails } from "../../redux/features/auth/authSlice";
import { getUser, signOutSubmit } from "../../redux/features/auth/authService";
import DefaultImage from '../../assets/images/icons/blank_profile_pic.png';
import LogoutIcon from '../../assets/images/icons/logout.png';
import ProfileIcon from '../../assets/images/icons/profile.png';
import TicketsIcon from '../../assets/images/icons/tickets.png';
import { showToast } from "../ToastMsg";
import { resetPurchasedCourses } from "../../redux/features/course/courseSlice";

const pages = [
    { name: "Home", path: "/" },
    { name: "Courses", path: "#courses" },
    { name: "About Us", path: "#about" },
    { name: "Contact", path: "#contact" }
];

const Navbar = ({ toggleSidebar }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { hasCheckedAuth, details } = useSelector(selectUserDetails);

    const [isOpen, setOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        dispatch(getUser());
    }, [dispatch]);

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const toggleLogin = () => navigate('/auth/login');
    const toggleSignUp = () => navigate('/auth/register');

    const handleLogout = () => {
        dispatch(signOutSubmit())
            .unwrap()
            .then(() => {
                dispatch(resetPurchasedCourses());
                navigate('/');
            })
            .catch((error) => {
                showToast("error", error.message);
            });
    }

    const toggleMyCourses = () => {
        navigate('/my-courses');
        setOpen(false);
    }

    const openProfile = () => {
        navigate('/my-profile');
        setOpen(false);
    }

    const handleNavigation = (e, path) => {
        if (path.startsWith("#")) {
            e.preventDefault();

            const sectionId = path.replace("#", "");
            const element = document.getElementById(sectionId);
            if (location.pathname === "/") {
                if (element) {
                    element.scrollIntoView({ behavior: "smooth" });
                }
            } else {
                navigate(`/${path}`);
            }
        }
        else if (path === "/" && location.pathname === "/") {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    return (
        <>
            <div className={styles.navContainer}>
                <div className={styles.navBar}>
                    <div className={styles.logoSec}>
                        <NavLink to={'/'}>
                            <img src={LogoImg} alt="Logo" className={styles.logoImg} width={140} />
                        </NavLink>
                    </div>
                    <div className={styles.pagesList}>
                        <ul className={styles.navList}>
                            {pages.map(({ name, path }) => (
                                <li key={name}>
                                    <NavLink to={path} className={({ isActive }) =>
                                        `${!isActive && !path.startsWith("#") ? styles.active : ""}`
                                    }
                                        onClick={(e) => handleNavigation(e, path)}>
                                        {name}
                                    </NavLink>
                                </li>
                            ))}
                            <li><NavLink to={'https://www.studyhub.lk/how-to-purchase'}>How to Purchase</NavLink></li>
                        </ul>
                    </div>
                    <div className={styles.rightSec}>
                        {hasCheckedAuth && (
                            details.id ? (
                                <>
                                    <div
                                        className={styles.profileSec}
                                        ref={dropdownRef}
                                    >
                                        <img
                                            src={details?.image_url ? details?.image_url : DefaultImage}
                                            className={styles.imageSec}
                                            onClick={() => setOpen(!isOpen)}
                                            alt="profile"
                                        />
                                        {isOpen ? (
                                            <div className={styles.dropdownMenu}>
                                                <div className={styles.profileHeader}>
                                                    <img
                                                        src={details?.image_url ? details?.image_url : DefaultImage}
                                                        className={styles.dropImageSec}
                                                        alt="Profile"
                                                    />
                                                    <div className={styles.nameSec}>
                                                        <p className={styles.name}>{details?.full_name}</p>
                                                        <p className={styles.email}>
                                                            {details?.email?.length > 25
                                                                ? `${details.email.slice(0, 22)}...`
                                                                : details?.email}
                                                        </p>
                                                    </div>
                                                </div>
                                                <ul className={styles.profileMenu}>
                                                    <li onClick={openProfile} className={styles.dropdownItem}>
                                                        <img src={ProfileIcon} width={24} />
                                                        Profile
                                                    </li>
                                                    <li onClick={toggleMyCourses} className={styles.dropdownItem}>
                                                        <img src={TicketsIcon} width={24} alt="My Tickets Icon" />
                                                        Courses
                                                    </li>
                                                    <li onClick={handleLogout} className={styles.dropdownItem}>
                                                        <img src={LogoutIcon} width={24} />
                                                        Logout
                                                    </li>
                                                </ul>
                                            </div>
                                        ) : null}
                                    </div>
                                </>
                            ) : (
                                <>
                                    <button type="button" className={styles.loginBtn} onClick={toggleLogin}>Login</button>
                                    <button type="button" className={styles.regBtn} onClick={toggleSignUp}>Register</button>
                                </>
                            )
                        )}
                        <div className={styles.barIcon} onClick={toggleSidebar}>
                            <FontAwesomeIcon icon={faBars} size="lg" style={{ color: '#1D0C50' }} />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Navbar;